module.exports = __webpack_public_path__ + "img/cover_storageboxSero_mobile.46a71391.png";